// src/App.js
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider }  from "./context/AuthContext";
import { ToastProvider } from "./components/Toast";
import Navbar            from "./components/Navbar";
import Footer            from "./components/Footer";
import ScrollToTop       from "./components/ScrollToTop";
import Home              from "./pages/Home";
import Auth              from "./pages/Auth";
import Downloads         from "./pages/Downloads";
import Generate          from "./pages/Generate";
import Categories        from "./pages/Categories";
import CategoryPage      from "./pages/CategoryPage";
import About             from "./pages/About";
import Contact           from "./pages/Contact";
import Privacy           from "./pages/Privacy";
import NotFound          from "./pages/NotFound";
import "./styles.css";

const App = () => (
  <AuthProvider>
    <ToastProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/"                    element={<Home />} />
          <Route path="/auth"                element={<Auth />} />
          <Route path="/downloads"           element={<Downloads />} />
          <Route path="/generate"            element={<Generate />} />
          <Route path="/categories"          element={<Categories />} />
          <Route path="/category/:slug"      element={<CategoryPage />} />
          <Route path="/about"               element={<About />} />
          <Route path="/contact"             element={<Contact />} />
          <Route path="/privacy"             element={<Privacy />} />
          <Route path="*"                    element={<NotFound />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </ToastProvider>
  </AuthProvider>
);

export default App;
